module.exports = __webpack_public_path__ + "static/media/KaWineAndDine_Badge_rides.42ac238d.jpg";